/**
 * Choose your energy — comparateur produit.
 *
 * - Desktop (>=990) : split 2 panneaux colles (actif large + teaser sombre).
 *   Le contenu s'ouvre/se ferme en douceur au changement d'actif. On change
 *   via le bouton DISCOVER du teaser ou en glissant (grab) horizontalement.
 *   Swiper est desactive a ce breakpoint.
 * - Mobile (<=989) : Swiper, une carte par slide ; le swipe change l'actif.
 * - Sync produit a l'echelle de la page : `data-active-product="{handle}"` sur
 *   <html> + CustomEvent `product:switch`.
 * - Parallax de fond au scroll (--ce-scroll). Respecte prefers-reduced-motion.
 */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESKTOP_MQ = window.matchMedia('(min-width: 990px)');
  var DRAG_THRESHOLD = 60;

  function setActiveProduct(handle) {
    if (!handle) return;
    if (document.documentElement.getAttribute('data-active-product') === handle) return;
    document.documentElement.setAttribute('data-active-product', handle);
    document.dispatchEvent(new CustomEvent('product:switch', { detail: { handle: handle } }));
  }

  function whenSwiperReady(cb) {
    if (window.Swiper) return cb();
    var tries = 0;
    var t = setInterval(function () {
      if (window.Swiper || tries++ > 100) {
        clearInterval(t);
        if (window.Swiper) cb();
      }
    }, 50);
  }

  class ChooseEnergy {
    constructor(root) {
      this.root = root;
      this.section = root.closest('.section-choose-energy') || root;
      this.el = root.querySelector('[data-ce-swiper]');
      if (!this.el) return;

      this.panels = Array.prototype.slice.call(root.querySelectorAll('.choose-energy__panel'));
      if (!this.panels.length) return;

      var initial = this.panels.filter(function (p) { return p.classList.contains('is-active'); })[0] || this.panels[0];
      this.current = initial.getAttribute('data-product');

      this.swiper = new window.Swiper(this.el, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        speed: REDUCED ? 0 : 1000,
        rewind: true,
        allowTouchMove: true,
        slideToClickedSlide: true, // mobile : clic sur une slide (peek) => l'activer
        a11y: { enabled: true },
        breakpoints: { 990: { enabled: false, spaceBetween: 0 } },
        on: {
          slideChange: this.onSlideChange.bind(this),
        },
      });

      root.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('product:switch', this.onExternalSwitch.bind(this));

      var self = this;
      this.onMediaChange = function () { self.syncMode(); };
      if (DESKTOP_MQ.addEventListener) DESKTOP_MQ.addEventListener('change', this.onMediaChange);
      else DESKTOP_MQ.addListener(this.onMediaChange);

      this.initDrag();
      this.syncMode();
      setActiveProduct(this.current);
      this.initScrollParallax();
    }

    swiperMode() {
      return !DESKTOP_MQ.matches; // mobile => Swiper actif
    }

    indexOfHandle(handle) {
      for (var i = 0; i < this.panels.length; i++) {
        if (this.panels[i].getAttribute('data-product') === handle) return i;
      }
      return -1;
    }

    activeHandle() {
      return this.current;
    }

    applyDesktop() {
      var activeIdx = this.indexOfHandle(this.current);
      this.panels.forEach(function (p, i) {
        var active = i === activeIdx;
        p.classList.toggle('is-active', active);
        // Fleche du teaser : vers la gauche s'il est a gauche de l'actif, sinon a droite
        p.classList.toggle('choose-energy__panel--teaser-left', !active && i < activeIdx);
      });
    }

    syncMode() {
      if (this.swiperMode()) {
        var idx = this.indexOfHandle(this.current);
        if (idx >= 0 && idx !== this.swiper.activeIndex) this.swiper.slideTo(idx, 0);
      } else {
        this.applyDesktop();
      }
    }

    setActive(handle) {
      if (!handle) return;
      this.current = handle;
      if (this.swiperMode()) {
        var idx = this.indexOfHandle(handle);
        if (idx >= 0) this.swiper.slideTo(idx);
      } else {
        this.applyDesktop();
      }
    }

    /* Desktop : activer le produit a un decalage (+1 / -1) en cyclant */
    step(delta) {
      var n = this.panels.length;
      if (n < 2) return;
      var idx = this.indexOfHandle(this.current);
      if (idx < 0) idx = 0;
      var target = ((idx + delta) % n + n) % n;
      var handle = this.panels[target].getAttribute('data-product');
      this.setActive(handle);
      setActiveProduct(handle);
    }

    onSlideChange() {
      if (!this.swiperMode()) return;
      var slide = this.swiper.slides[this.swiper.activeIndex];
      var handle = slide ? slide.getAttribute('data-product') : null;
      if (!handle) return;
      this.current = handle;
      setActiveProduct(handle);
    }

    onClick(e) {
      // Bouton DISCOVER explicite
      var btn = e.target.closest('[data-ce-nav]');
      if (btn && this.root.contains(btn)) {
        e.preventDefault();
        var target = btn.getAttribute('data-target');
        if (!target || target === this.current) return;
        this.setActive(target);
        setActiveProduct(target);
        return;
      }

      // Desktop : clic sur un panneau teaser => l'activer (sauf apres un drag,
      // ou en cliquant un lien/bouton du contenu)
      if (this.swiperMode() || this.didDrag) return;
      if (e.target.closest('a, button')) return;
      var panel = e.target.closest('.choose-energy__panel');
      if (!panel || panel.classList.contains('is-active')) return;
      var handle = panel.getAttribute('data-product');
      if (!handle || handle === this.current) return;
      this.setActive(handle);
      setActiveProduct(handle);
    }

    onExternalSwitch(e) {
      var handle = e.detail && e.detail.handle;
      if (!handle || handle === this.current) return;
      this.setActive(handle); // pas de re-emit : data-active-product deja pose
    }

    /* Desktop : glisser horizontalement (grab) pour changer de fiche */
    initDrag() {
      var self = this;
      var startX = 0;
      var dragging = false;

      this.el.addEventListener('pointerdown', function (e) {
        if (self.swiperMode()) return; // mobile : Swiper gere le drag
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true;
        startX = e.clientX;
      });

      window.addEventListener('pointerup', function (e) {
        if (!dragging) return;
        dragging = false;
        if (self.swiperMode()) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        // Marque un vrai drag pour que le clic qui suit n'active pas un panneau
        self.didDrag = true;
        setTimeout(function () { self.didDrag = false; }, 0);
        self.step(dx < 0 ? 1 : -1); // glisse a gauche => suivant
      });
    }

    /* Parallax au scroll — fond seul (--ce-scroll sur la section) */
    initScrollParallax() {
      if (REDUCED) return;
      var self = this;
      var range = 110; // amplitude en px
      var ticking = false;

      function update() {
        ticking = false;
        var rect = self.section.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = (vh / 2 - (rect.top + rect.height / 2)) / (vh / 2 + rect.height / 2);
        progress = Math.max(-1, Math.min(1, progress));
        self.section.style.setProperty('--ce-scroll', (progress * range).toFixed(1) + 'px');
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }
  }

  function init() {
    document.querySelectorAll('[data-choose-energy]').forEach(function (root) {
      if (root.__chooseEnergy) return;
      root.__chooseEnergy = true;
      whenSwiperReady(function () {
        new ChooseEnergy(root);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
